<template>
  <div class="page">
    <form class="card" @submit.prevent="onSubmit">
      <h1>로그인</h1>
      <label class="field">
        <span>아이디</span>
        <input v-model.trim="id" autocomplete="username" />
      </label>

      <label class="field">
        <span>비밀번호</span>
        <input v-model="pw" type="password" autocomplete="current-password" />
      </label>

      <button class="btn" type="submit">로그인</button>
      <div>
        <small class="error">{{ errMsg }}</small>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { memberApi } from "@/api";

const router = useRouter();

const id = ref("");
const pw = ref("");
const errMsg = ref("");

async function onSubmit() {
  const res = await memberApi.login(id.value, pw.value);
  if (res) {
    errMsg.value = "";
    router.replace("/admin/manage");
  } else {
    errMsg.value = "아이디 또는 비밀번호가 틀렸습니다.";
  }
}
</script>

<style scoped>
.page {
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: #f6f7f9;
}
.card {
  width: 360px;
  background: #fff;
  border: 1px solid #e6e8eb;
  border-radius: 12px;
  padding: 16px;
  display: grid;
  gap: 12px;

  h1 {
    text-align: center;
  }
}
.field {
  display: grid;
  gap: 6px;
}
.field input {
  border: 1px solid #e6e8eb;
  border-radius: 10px;
  padding: 10px;
}
.btn {
  border: 1px solid #111;
  border-radius: 10px;
  padding: 10px;
  background: #111;
  color: #fff;
  cursor: pointer;
}
.error {
  color: #d93025;
  font-size: 12px;
}
</style>
